import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import { updateThemeTable } from 'modules/think-seeds/actions';
import ThemeTableEdit from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.creationThinkSeed || {},
    tables: state.thinkChats.myThinkChatsList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    updateThemeTable: bindActionCreators(updateThemeTable, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThemeTableEdit));



// WEBPACK FOOTER //
// ./src/routes/ThemeTableEdit/container/index.js